"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { resolveUrl } from "../util/UrlUtils";
import { REFERRING_TEST_SERVER_COOKIE_NAME } from "../consts";
import { useWatchedCookie } from "./useWatchedCookie";

/**
 * Hook that returns the Academy URL based on the referringTestServer cookie.
 *
 * This hook prevents hydration mismatches by:
 * 1. Initializing with the default URL (matches server render)
 * 2. Updating to the cookie-based URL after mount (client-only)
 *
 * @returns The Academy URL without trailing slash
 */
export function useAcademyUrl() {
  const $ = _c(4);
  const referring = useWatchedCookie(REFERRING_TEST_SERVER_COOKIE_NAME);
  const defaultAcademyUrl = process.env.NEXT_PUBLIC_ACADEMY_URL;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => resolveUrl({
      defaultUrl: defaultAcademyUrl,
      type: "academy"
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [academyUrl, setAcademyUrl] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== referring) {
    t1 = () => {
      const resolvedAcademyUrl = resolveUrl({
        defaultUrl: defaultAcademyUrl,
        type: "academy",
        referringTestServer: referring
      });
      setAcademyUrl(resolvedAcademyUrl);
    };
    t2 = [referring, defaultAcademyUrl];
    $[1] = referring;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return academyUrl;
}